import React, { Component } from "react";
import "./ppfdashboard.css";
import { t } from "i18next";
import {
  BreadCrumb,
  Button,
  CardDetailContainer,
  Header,
  TitleView,
  SideModel,
  Toast,
  ProgressDialog,
} from "../../components";
import * as Bl from "../../../businesslogic";
import {
  getFinancialNonMarketPath,
  getFormatAmount,
  getUserId,
} from "../../common";
import { INVESTMENT_CATEGORY } from "../../constants";
import * as logger from "../../utils/logger/index";

class PPFDashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditView: false,
      showModal: false,
      investmentData: [],
    };
    this.isRenderingAlready = false;
  }
  componentDidMount() {
    if (!this.isRenderingAlready) {
      this.isRenderingAlready = true;
      this.getUserInvestmentByCategory();
    }
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onClickMoreIcon() {
    this.setState({ showEditView: !this.state.showEditView });
  }

  onClickEditIcon = (selectedItem) => {
    this.props.navigate("/ppfdetailspage", {
      state: { investmentData: selectedItem.item, isEditView: true },
    });
  };

  onPressAddMoreView() {
    this.props.navigate("/ppfhome");
  }

  onPressSaveButton() {
    this.props.navigate("/financialdetails");
  }

  onClickCancel() {
    this.setState({ showModal: false });
  }

  onPressNo() {
    this.setState({ showModal: false });
  }

  onPressYes(selectedItem) {
    this.deleteInvestment(selectedItem.item);
  }
  hideToast() {
    this.setState({ toastMessage: "", showToast: false });
  }

  showToast(toastMessage) {
    this.setState(
      { toastMessage, showToast: true, showProgress: false },
      () => {
        setTimeout(() => {
          this.hideToast();
        }, 3000);
      }
    );
  }

  getTotalBalance(list) {
    const totalArray = [];
    list.forEach((item) => {
      totalArray.push({
        money: item.currentvalue,
      });
    });
    const total = totalArray.reduce((a, v) => (a = a + v.money), 0);
    return total;
  }

  prepareCardData(list) {
    const displayData = [];
    list.forEach((item) => {
      displayData.push({
        title: "PPF",
        currencyLabel: "Current Value",
        money: item.currentvalue,
        extraContent: item?.fvatretirement ? `Maturity Value  :  ₹ ${getFormatAmount(item.fvatretirement)} | ${item.maturityyear}` : "",
        item,
      });
    });
    return displayData;
  }
  getUserInvestmentByCategory() {
    const data = {
      uuid: getUserId(),
      category: INVESTMENT_CATEGORY.PPF,
    };

    this.setState({ showProgress: true }, () => {
      Bl.Investment.getUserInvestmentByCategory(data)
        .then((list) => {
          this.setState({ showProgress: false, investmentData: list });
        })
        .catch((error) => {
          logger.error({ error });
          this.showToast(t("someErrorHasOccured"));
        });
    });
  }

  deleteInvestment(item) {
    const investmentObj = new Bl.Investment(item);
    this.setState({ showProgress: true }, () => {
      investmentObj
        .deleteInvestment()
        .then(() => {
          const newList =
            this.state.investmentData &&
            this.state.investmentData.filter((e) => e.id !== item.id);
          this.setState({ investmentData: newList, showProgress: false });
        })
        .catch((error) => {
          logger.error({ error });
          this.showToast(t("someErrorHasOccured"));
        });
    });
  }

 
  renderNavView() {
    const items = getFinancialNonMarketPath("PPF");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("networthAssetsFNM5");
    return <TitleView title={title} information={""} />;
  }

  renderExpectedValueView() {
    const totalBalance = this.getTotalBalance(this.state.investmentData);
    const displayAmount = getFormatAmount(totalBalance);
    return (
      <div className="pd_expect_value_view">
        <label className="pd_value_text">
          {t("ppfDBValue")}: ₹ {displayAmount}
        </label>
      </div>
    );
  }

  renderCardView() {
    const cardData = this.prepareCardData(this.state.investmentData);

    return (
      <div className="pd_card_view">
        {cardData.map((card, index) => (
          <CardDetailContainer
            key={index}
            title={card.title}
            currentValue={card.currencyLabel}
            money={card.money}
            extraContent={card.extraContent}
            onClickEdit={() => this.onClickEditIcon(card)}
            onPressNo={this.onPressNo.bind(this)}
            onPressYes={() => this.onPressYes(card)}
          />
        ))}
      </div>
    );
  }

  renderButtonsView() {
    return (
      <div className="pd_bottomView">
        <div className="pd_buttonView">
          <div className="pd_addmore_button">
            <Button
              buttonName={t("ppfDBButton1")}
              emptyButton={true}
              onPressButton={this.onPressAddMoreView.bind(this)}
            />
          </div>
          <div className="pd_save">
            <Button
              buttonName={t("ppfDBButton2")}
              onPressButton={this.onPressSaveButton.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }

  renderContentView() {
    return (
      <div className="pd_content_view">
        {this.renderTitleView()}
        {this.renderExpectedValueView()}
        {this.renderCardView()}
      </div>
    );
  }
  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  renderToastView() {
    return (
      <Toast
        showToast={this.state.showToast}
        toastMessage={this.state.toastMessage}
      />
    );
  }

  renderProgressDialog() {
    return (
      <ProgressDialog
        showProgress={this.state.showProgress}
        progressMessage={this.state.progressMessage}
      />
    );
  }

  render() {
    return (
      <div className="pd_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {this.renderButtonsView()}
        {/* {this.renderDrawerContent()} */}
        {this.renderToastView()}
        {this.renderProgressDialog()}
      </div>
    );
  }
}

export default PPFDashBoard;
